import { render, staticRenderFns } from "./AdminPartnerCalculationsReturnsPage.vue?vue&type=template&id=1bcb7c04&scoped=true"
import script from "./AdminPartnerCalculationsReturnsPage.vue?vue&type=script&lang=js"
export * from "./AdminPartnerCalculationsReturnsPage.vue?vue&type=script&lang=js"
import style0 from "./AdminPartnerCalculationsReturnsPage.vue?vue&type=style&index=0&id=1bcb7c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb7c04",
  null
  
)

export default component.exports